import React from 'react';
import { useNavigate } from 'react-router-dom';

const tools = [
  {
    path: '/impairment/review',
    title: 'Report Review',
    description: 'Check a completed report for accuracy, consistency, repetition and completeness',
    color: '#0891b2',
    status: 'available',
  },
  {
    path: '/impairment/respiratory',
    title: 'Respiratory Impairment',
    description: 'AMA 4th Ed, Table 8 — FVC, FEV\u2081, DLCO pulmonary function',
    color: '#2563eb',
    status: 'available',
  },
  {
    path: null,
    title: 'Combined Values Chart',
    description: 'AMA 4th Ed, p.322 — Combine multiple body system impairments',
    color: '#7c3aed',
    status: 'coming soon',
  },
  {
    path: null,
    title: 'Spine Impairment',
    description: 'AMA 4th Ed — DRE and ROM methods for cervical, thoracic, lumbar',
    color: '#059669',
    status: 'coming soon',
  },
  {
    path: null,
    title: 'Upper Extremity',
    description: 'AMA 4th Ed — Shoulder, elbow, wrist, hand impairment',
    color: '#dc2626',
    status: 'coming soon',
  },
  {
    path: null,
    title: 'Lower Extremity',
    description: 'AMA 4th Ed — Hip, knee, ankle, foot impairment',
    color: '#ea580c',
    status: 'coming soon',
  },
];

export default function ImpairmentToolsPage() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, color: '#111827' }}>
          Impairment Assessment Tools
        </h1>
        <p style={{ margin: '8px 0 0', fontSize: 14, color: '#6b7280' }}>
          AMA Guides 4th Edition calculators for whole person impairment ratings
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
        {tools.map((tool) => (
          <div
            key={tool.title}
            onClick={() => tool.path && navigate(tool.path)}
            style={{
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              padding: '24px',
              cursor: tool.path ? 'pointer' : 'default',
              transition: 'all 0.15s ease',
              opacity: tool.path ? 1 : 0.6,
              borderLeft: `4px solid ${tool.color}`,
            }}
            onMouseEnter={(e) => {
              if (tool.path) {
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = tool.color;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.borderColor = '#e5e7eb';
              e.currentTarget.style.borderLeftColor = tool.color;
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#111827' }}>
                {tool.title}
              </h3>
              {tool.status === 'coming soon' && (
                <span style={{
                  fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em',
                  padding: '3px 8px', borderRadius: 4, backgroundColor: '#f3f4f6', color: '#6b7280',
                }}>
                  Coming soon
                </span>
              )}
            </div>
            <p style={{ margin: 0, fontSize: 13, color: '#6b7280', lineHeight: 1.5 }}>
              {tool.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
